import * as types from '../mutation-types';
import ConversationAPI from '../../api/inbox/conversation';
import * as Sentry from '@sentry/vue';

const state = {
  records: {},
};

export const getters = {
  getUserList: $state => id => {
    return $state.records[Number(id)] || [];
  },
};

export const actions = {
  markReading: async (_, { conversationId }) => {
    try {
      await ConversationAPI.markReading({ conversationId });
    } catch (error) {
      Sentry.captureException(error);
    }
  },
  create: ({ commit }, { conversationId, user }) => {
    commit(types.default.ADD_USER_READING_CONVERSATION, {
      conversationId,
      user,
    });
  },
  destroy: ({ commit }, { conversationId, user }) => {
    commit(types.default.REMOVE_USER_READING_CONVERSATION, {
      conversationId,
      user,
    });
  },
};

export const mutations = {
  [types.default.ADD_USER_READING_CONVERSATION]: (
    $state,
    { conversationId, user }
  ) => {
    const records = $state.records[conversationId] || [];
    const alreadyPresent = records.some(
      r => r.id === user.id && r.type === user.type
    );
    if (!alreadyPresent) {
      $state.records = {
        ...$state.records,
        [conversationId]: [...records, user],
      };
    }
  },
  [types.default.REMOVE_USER_READING_CONVERSATION]: (
    $state,
    { conversationId, user }
  ) => {
    const records = $state.records[conversationId] || [];
    $state.records = {
      ...$state.records,
      [conversationId]: records.filter(
        r => r.id !== user.id || r.type !== user.type
      ),
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
